import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import React, { useEffect } from 'react';

import MessageBoard from '../Atoms/MessageBoard/';
import Moment from './Moment';

//The parent component, a literal container for Channels List and Channels View

const MomentDetails = (props: any) => {
    const { addComment, blockMoment, fetchUserAvatar, match, moment, removeMoment, setActiveMoment } = props;
    const { moment_id } = match.params;
    useEffect(() => {
        setActiveMoment(moment_id);
    }, [setActiveMoment, moment_id]);
    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={3}>
                    <Moment
                        fetchUserAvatar={fetchUserAvatar}
                        post={moment}
                        remove={removeMoment}
                        setActive={setActiveMoment}
                    />
                </Grid>
                <Grid item xs={9}>
                    <MessageBoard
                        blockedStatusField="isBlockedByAdmin"
                        data={moment.comments}
                        fetchUserAvatar={fetchUserAvatar}
                        flagged={'flagged'}
                        handleNewMessage={addComment}
                        heading=""
                        name="senderName"
                        text="text"
                        timestamp="timestamp"
                        toggleBlock={({ id, status }: any) => blockMoment({ id: id, isBlockedByAdmin: status })}
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(MomentDetails);
